import {
  OrderType,
  Side,
} from '@paradigm/features/src/unified-rfqs/entities/shared';
import { convertToBigNumber } from '@paradigm/utils/formatDecimal';
import { Nullable } from '@paradigm/utils/types';
import {
  DrfqState,
  DrfqVenueCode,
  Role,
} from '#/unified-rfqs/entities/drfq/domain';

export type TimeInForce = 'GOOD_TILL_CANCELED' | 'FILL_OR_KILL';

export interface Order {
  readonly rfqType: 'drfq';
  readonly id: string;
  readonly rfq_id: string;
  readonly state: DrfqState;
  readonly side: Side;
  readonly type: OrderType;
  readonly time_in_force: TimeInForce;
  readonly account_name: string;
  readonly role: Role;
  readonly venue: DrfqVenueCode;
  readonly quantity: string;
  readonly filled_quantity: string;
  readonly pending_fill_quantity: string;
  readonly canceled_quantity: string;
  readonly price: string;
  readonly label: string;
  readonly legs: OrderLeg[];
  readonly created_at: Date;
  readonly last_updated_at: Date;
}

export interface OrderLeg {
  price: string;
  instrument_id: number;
}

export interface RfqOrder {
  readonly quantity: string;
  readonly price: string;
  readonly id: string;
  readonly desk: Nullable<string>;
  readonly isNew?: boolean;
  readonly type: OrderType;
}

export function isOrderExecuted(order: Order) {
  return convertToBigNumber(order.filled_quantity).gt(0);
}

export function isBidOrder(order: Order) {
  return order.side === 'BUY';
}

export function isAskOrder(order: Order) {
  return order.side === 'SELL';
}
